/***
 *Create by omarenco
 *
 * Contiene todos los End Point de la aplicacion
 */
import { environment } from '../environments/environment';
import { BillingStatusEnum } from './core/enums/billing-status.enum';
import { FaxRequestedEnum } from './core/enums/fax-requested.enum';
import { ModalNameEnum, StepperEnum, TabsDepositsEnum, TabsElectronicEnum } from './core/enums/tabs-deposits.enum';
import { TabsServiceProviderEnum } from './core/enums/tabs-service-provicer.enum';
import { TabsDenialsEnum } from './core/enums/tabs-denials-enum';
import { TabsUnverifiedTripsEnum } from './core/enums/tabs-unverified-trips.enum';

export const constant = {
  BASIC: environment.url_api ,

  SERVER_WITH_SIGNALR: environment.url_signalr,
  ENFORCED_PASSWORD_MIN_LENGTH: 11,
  MAX_INACTIVITY_MINS: 15,
  VIN_LENGTH: 17,

  URL_IMAGE_PLACE_HOLDER: '../assets/images/svg/picture-default.svg',
  URL_COMPANIES: environment.url_api + 'Company',
  URL_COMPANY: environment.url_api + 'Company/',
  URL_COMPANY_BY_ID: environment.url_api + 'Company/GetById',
  URL_DISABLE_COMPANIES: environment.url_api +  'Company?showDisabled=true',
  URL_ENABLE_COMPANIES: environment.url_api +  'Company?showDisabled=false',
  URL_SCAN_IMAGE: environment.url_api +  'ImageController/' + 'UploadVoidCheck',
  URL_COMPANY_GET_EMS_PROVIDERS: environment.url_api + 'Company/GetEmsProviders',
  URL_COMPANY_GETAPIID: environment.url_api + 'Company/GetApiId',
  URL_COMPANY_POST_PROVIDER_SETTING: environment.url_api + 'Company/SaveProviderSetting',
  URL_COMPANY_PUT_PROVIDER_SETTING: environment.url_api + 'Company/UpdateProviderSetting',
  URL_COMPANY_PROVIDER_SETTING_GET: environment.url_api + 'Company/GetProviderSetting',
  URL_COMPANY_PROVIDER_GENERATE_CLIENT_SECRET: environment.url_api + 'Company/GetClientSecret',
  URL_COMPANY_PROVIDER_POST_OAUTH_CLIENT: environment.url_api + 'Company/SaveOauthClient',
  URL_COMPANY_PROVIDER_PUT_OAUTH_CLIENT: environment.url_api + 'Company/UpdatePutOauthClient',
  URL_COMPANY_PROVIDER_GET_OAUTH_CLIENT: environment.url_api + 'Company/GetOauthClient',
  /***
   * PCPS ENDPOINT
   */
    URL_PCP: environment.url_api +  'PrimaryCarePhysician/',

  /**
   *PROVIDERS ENDPOINT
   */
  URL_PROVIDER: environment.url_api +  'Broker/',
  URL_DISABLE_PROVIDER: environment.url_api +  'Broker?showDisabled=true',
  URL_ENABLE_PROVIDER: environment.url_api +  'Broker?showDisabled=false',
  URL_GET_BROKERS_BY_PAYOR: environment.url_api +  'FeeSchedule/ListBrokersByPayor/',
  URL_GET_BROKERS_TRIP_NUMBER: environment.url_api +  'Trip/CountTripsByBroker/',
  URL_GET_COMPANY_TRIP_COUNT: environment.url_api +  'Trip/CountTripsByCompany/',

  URL_PROVIDER_TYPE: environment.url_api + 'ProviderType',
  URL_PROVIDER_TYPE_TRIPS: environment.url_api + 'ProviderType/ProviderTypesTrips',

  /**
   * REPORTS
   */
  URL_GENERIC_REPORT: environment.url_api + 'ReportManager/GetReportUrl',
  URL_BATCH_REPORT: environment.url_api + 'ReportManager/GetBatchReportUrl',

  /**
   * BROKERS
   */
  BROKERS: {
    DESCRIPTION: 'Esto apunta a las companies',
    URLS: {
      BASE: environment.url_api + 'Broker/'
    }
  },

  /**
   * USER ENDPOINT
   */
  URL_USER_PROFILE: environment.url_api +  'UserProfile',
  URL_USER_PROFILE_POST: environment.url_api +  'UserProfile/register',
  URL_USER_PROFILE_GET_USER: environment.url_api +  'UserProfile/GetUserProvider',
  URL_USER_PROFILE_GET_FILTER: environment.url_api +  'UserProfile/list',
  URL_USER_PROFILE_BY_ID: environment.url_api +  'UserProfile/',
  URL_CHANGE_PASSWORD: environment.url_api +  'UserProfile/updatePassword',
  URL_CLOSE_ALL_SESSIONS: environment.url_api +  'Session/DeleteAll',
  URL_UPDATE_AVATAR: environment.url_api + 'UserProfile/ChangeUserPhoto',
  URL_GET_MESSAGES_BY_USER: environment.url_api + 'Message/ByUser',
  URL_PUT_MESSAGES: environment.url_api + 'Message/Read',

  URL_CONFIGURATION_DATA: environment.url_api + 'Configuration/SupportChannels',
  URL_ACTIVE_MANAGER_USERS: environment.url_api + 'UserProfile/ManagedUsers',
  URL_REMOVE_MANAGED_USERS_RELATION: environment.url_api + 'UserProfile/ManagedUsers/RemoveRelation',
  URL_USER_PRODUCTIVITY_ACTIVITY_HISTOGRAM: environment.url_api + 'UserProfile/Productivity/ActivityHistogram',
  URL_USER_PRODUCTIVITY_SUBORDINATES: environment.url_api + 'UserProfile/Productivity/Subordinates',
  /**
   * ROLES ENPOINT
   */
  URL_ROLE: environment.url_api +  'Role',
  URL_ROLEACTIONS: environment.url_api +  'RoleAction?RoleID=',
  URL_ROLEACTIONAPI: environment.url_api +  'RoleAction',
  URL_ROLEACTIONCREATE: environment.url_api +  'RoleAction/Create',
  URL_ACTION_BY_MODULE: environment.url_api +  'RoleAction/SearchByModule',
  URL_USER_ACTIVE_SESSIONS: environment.url_api +  'Trip2Driver/',
  /**
   * MODULE-ACTIONS ENDPOINT
   */
  URL_MODULE: environment.url_api +  'Module',
  URL_MODULE_ACTION: environment.url_api +  'ModuleAction',
  /**
   *MODULES & ACTIONS ENDPOINT
   */
  URL_ACTION: environment.url_api +  'Action',
  URL_MODULEACTION: environment.url_api +  'ModuleAction',
  URL_GETMODULEACTION: environment.url_api +  'RoleAction/SearchByModule',
  URL_SAVE_LAYOUT: environment.url_api +  'UserProfile/SaveLayout',
  URL_LAYOUT_MINE: environment.url_api + 'Layout/Mine/',
  URL_LAYOUT_PUBLIC: environment.url_api + 'Layout/Public/',
  URL_LAYOUT_PUBLIC_DETAIL: environment.url_api + 'Layout/Public/Detail/',
  URL_LAYOUT_PUBLISH: environment.url_api + 'Layout/Publish',
  URL_LAYOUT_UNPUBLISH: environment.url_api + 'Layout/Unpublish/',
  URL_LAYOUT_APPLY: environment.url_api + 'Layout/Apply/',
  URL_MODULEACTIONBYMOD: environment.url_api +  'ModuleAction?moduleid=',
  /**
   * TIME RULE ENDPOINT
   */
  URL_TIME_RULE: environment.url_api + 'TimeRule',
  /**
   * Vehicle Services
   * @type {string}
   */
  URL_VEHICLE_TYPE: environment.url_api +  'VehicleType',
  URL_VEHICLE: environment.url_api +  'Vehicle',
  URL_VEHICLE_GET_VEHICLE_BY_ID: environment.url_api +  'Vehicle/GetVehicle',
  URL_VEHICLE_GET_BY_PROVIDERID: environment.url_api +  'Vehicle?showDisable=false&code=&ondemand=false&providerId=',
  URL_VEHICLE_VEHICLE: environment.url_api +  'VehiclePhoto/Vehicle',
  URL_VEHICLE_COLORS: environment.url_api +  'Vehicle/ListColors',
  URL_VEHICLE_COMPANY: environment.url_api +  'Vehicle/Company/',
  URL_CALL_TYPE: environment.url_api +  'Vehicle/CallType',
  URL_VEHICLE_PHOTO_TYPE: environment.url_api +  'VehiclePhoto/Type',
  URL_PHOTO_BY_VEHICLE_ID: environment.url_api +  'Vehicle/SearchPhotosByVehicle',
  URL_VEHICLE_PHOTO_BY_ID: environment.url_api +  'VehiclePhoto/Vehicle',
  URL_VEHICLE_STATUS: environment.url_api +  'Vehicle/VehicleStatus',
  URL_VEHICLE_VIN: environment.url_api +  'Vehicle/SearchByVINApi',
  URL_VEHICLE_VIN_LOOKUP: environment.url_api + 'Vehicle/VinLookup/',
  URL_VEHICLE_CHECK_VIN: environment.url_api + 'Vehicle/CheckVin/',
  URL_VEHICLE_MAKES: environment.url_api +  'Vehicle/ListMakes',
  URL_VEHICLE_MODELS: environment.url_api +  'Vehicle/ListModels',
  URL_VEHICLE_YEARS: environment.url_api +  'Vehicle/ListYears',
  URL_VEHICLE_PHOTO: environment.url_api +  'VehiclePhoto',
  URL_VEHICLE_BY_DRIVER: environment.url_api +  'Vehicle/ListByDriverId',
  URL_TRIP2_DRIVER_ACTIVE: environment.url_api +  'Trip2Driver/DriversActive',
  URL_TRIP2_DRIVER_ALL: environment.url_api +  'Trip2Driver/AllDrivers',
  URL_VEHICLE_CYCLE: environment.url_api +  'VehicleCycle',
  URL_VEHICLE_TYPE_DOC: environment.url_api +  'VehicleTypeLicense',
  URL_VEHICLE_LICENSE: environment.url_api +  'VehicleLicense',
  URL_VEHICLE_IMPORT_TEMPLATE: environment.url_api +  'ImportFile/VehiclesTemplate',
  URL_VEHICLE_IMPORT: environment.url_api +  'ImportFile/vehicles',
  URL_VEHICLE_CHANGE_ACTIVE: environment.url_api + 'Vehicle/UpdateIsActiveVehicle',
  /**
   * MAKES VEHICLE ENDPOINT
   */
  URL_VEHICLE_ONLY_MAKES: environment.url_api + 'Vehicle/ListMakesOnly',
  /**
   * CALLTYPES ENDPOINT
   * */
  URL_CREATE_CALL_TYPE: environment.url_api +  'Vehicle/CreateCallType',
  URL_UPDATE_CALL_TYPE: environment.url_api +  'Vehicle/UpdateCallType',
  URL_DELETE_CALL_TYPE: environment.url_api +  'Vehicle/DeleteCallType',
  URL_GET_CALL_TYPE: environment.url_api +  'Vehicle/CallTypeById',
  /**
   * VEHICLE CAPACITY
   */

   URL_CAPACITY: environment.url_api + 'VehicleCapacity',
  /**
   * INSPECTIONS ENDPOINT
   */
  URL_GET_INSPECTIONS: environment.url_api +  'Trip2Driver/Inspections/',
  /**
   * DRIVERS ENDPOINT
   * @type {string}
   */
  URL_DRIVERS: environment.url_api +  'MCTdriver',
  URL_CURRENT_LOCATION_BY_DRIVER: environment.url_api +  'MCTDriver/CurrentLocationByDriver',
  URL_CREATE_DRIVER: environment.url_api +  'MCTDriver/CreateDriver',
  URL_SEND_DRIVER: environment.url_api +  'Integration/SendDriversToOrigin',
  URL_SEND_VIDEO_DRIVER: environment.url_api +  'DriverToken/GenerateTokenVideo',
  URL_SEND_VEHICLE: environment.url_api +  'Integration/SendVehiclesToOrigin',
  LIST_URL_DRIVERS: environment.url_api +  'MCTdriver/List',
  URL_GET_DRIVER_BY_PROVIDER: environment.url_api +  'MCTDriver/List/',
  LIST_URL_DRIVERS_PROVIDER: environment.url_api +  'MCTDriver/ListByFilter',
  LIST_URL_DOCUMENTS: environment.url_api +  'MCTDriver/Documents',
  LIST_URL_LICENSES: environment.url_api +  'MCTDriver/Licenses',
  URL_PENDING_DOCUMENTS_COUNT: environment.url_api +  'MCTDriver/PendingDocumentsCount',
  URL_IMPORT_PENDING_DOCUMENTS: environment.url_api +  'MCTDriver/ImportPendingDocuments',
  LIST_URL_LICENSES_TYPE: environment.url_api +  'MCTDriver/TypeLicenses',
  LIST_URL_PROFILE_LOG: environment.url_api +  'MCTDriver/History',
  POST_URL_DRIVER_DOC: environment.url_api +  'MCTDriver/RegisterDocument',
  POST_URL_DRIVER_LIC: environment.url_api +  'MCTDriver/RegisterLicense',
  POST_URL_DRIVER_LIC_BULK: environment.url_api +  'MCTDriver/RegisterLicensesBulk',
  URL_DRIVERS_BY_VEHICLE: environment.url_api +  '/Vehicle/DriverByVehicle/',
  URL_VALID_MCT_DRIVERS: environment.url_api +  'MCTDriver/ValidDriver/',
  URL_DRIVER_LASTLOCATION: environment.url_api +  'Vehicle/LastLocationDriver/',
  URL_DRIVER_IMPORT_TEMPLATE: environment.url_api +  'ImportFile/DriversTemplate',
  URL_DRIVER_IMPORT: environment.url_api +  'ImportFile/drivers',
  URL_DRIVER_STATUS_PROVIDER: environment.url_api + 'ProviderDriverStatus',
  URL_UPDATE_DRIVER: environment.url_api + 'MCTDriver/UpdateLicense',
  URL_GET_MODULES_COURSES: environment.url_api +  'DriverToken/GetModulesCoursesDriver/',
  URL_GET_DOWNLOAD_CERTIFICATED: environment.url_api + 'DriverToken/GenerateCertificate/',
  URL_VERIFY_LICENSE_DRIVER: environment.url_api + 'MCTDriver/VerifyLicense',
  URL_GET_REPORTS: environment.url_api + 'BackgroundCheck/CheckrReportDates',
  URL_GET_REPORT_INFO: environment.url_api + 'BackgroundCheck/CheckrReports',
  URL_RUN_BACKGROUND: environment.url_api + 'BackgroundCheck/CreateReportCheckr',
  URL_UPDATE_ACTIVE: environment.url_api + 'BackgroundCheck/UpdateActive',

  URL_UNIFIED_BACKGROUND_CHECK_DATES: environment.url_api + 'UnifiedBackgroundCheck/Dates/',
  URL_UNIFIED_BACKGROUND_CHECK_REPORT_DETAIL: environment.url_api + 'UnifiedBackgroundCheck/ReportDetail/',
  URL_UNIFIED_BACKGROUND_CHECK_DOWNLOAD: environment.url_api + 'UnifiedBackgroundCheck/Download/',
  URL_UNIFIED_BACKGROUND_CHECK_RUN_CHECK: environment.url_api + 'UnifiedBackgroundCheck/RunCheck/',
  URL_UNIFIED_BACKGROUND_CHECK_ACTIVATE: environment.url_api + 'UnifiedBackgroundCheck/Activate/',
  URL_UNIFIED_BACKGROUND_CHECK_DEACTIVATE: environment.url_api + 'UnifiedBackgroundCheck/Deactivate/',

  URL_REACTIVE_ACCOUNT_MTCDRIVER: environment.url_api + 'MCTDriver/ReactivateAccount',
  URL_CHECK_EMPLOYEE_ID: environment.url_api + 'MCTDriver/CheckEmployeeId/',
  URL_EMPLOYEE_LOOKUP: environment.url_api + 'MCTDriver/EmployeeLookup/',
  URL_MCT_DRIVER_PHOTO: environment.url_api + 'MCTDriver/UpdateProfilePhoto',
  URL_RACE: environment.url_api + 'Race',

  /**
   * PROMPT ENDPOINTS
   */
  URL_PROMPT_LIST: environment.url_api + 'EmscribePrompt/List',
  URL_PROMPT_CREATE: environment.url_api + 'EmscribePrompt/Create',
  URL_PROMPT_UPDATE: environment.url_api + 'EmscribePrompt/Update',
  URL_PROMPT_RESTORE: environment.url_api + 'EmscribePrompt/Restore/',
  URL_PROMPT_DELETE: environment.url_api + 'EmscribePrompt/Delete/',
  URL_PROMPT_ANALYZE: environment.url_api + 'EmscribePrompt/Analyze',

  /**ZONES
   */
  URL_ZONES: environment.url_api + 'Zone',
  URL_GETZONES: environment.url_api + 'Zone/GetZones',
  URL_TRIP_AUTOASSIGN_DRIVER: environment.url_api + 'Trip/AssignDriverByZone',

  /**
   * ON DEMAND DRIVERS ENDPOINT
   */
  URL_ONDEMAND_DRIVERS: environment.url_api +  'Trip2Driver',
  URL_SIGNATURE_TRIP: environment.url_api +  'Trip2Driver/SignRiderTrip2Sync',
  URL_TRIP_HISTORY_DRIVER: environment.url_api +  'Trip2Driver/TripHistory',
  URL_LOG_DRIVER: environment.url_api +  'Trip2Driver/SessionsDriver',
  URL_USER_DEVICE: environment.url_api +  'UserDevice/List',

  URL_GET_STATUS: environment.url_api +  'Trip2Driver/DriverStates/3',
  URL_GET_STATUS_REJECTED_REASON: environment.url_api +  'Trip2Driver/DriverStates/4',
  URL_GET_REFERRALS: environment.url_api +  'Trip2Driver/ListReferrals',
  URL_GET_BANKS: environment.url_api +  'Trip2Driver/Banks',
  URL_ADD_INSPECTION: environment.url_api +  'Trip2Driver/AddInspection',
  URL_GET_DOCUMENTS: environment.url_api +  'Trip2Driver/Documents',
  URL_VALID_DRIVER: environment.url_api +  'Trip2Driver/ValidDriver',
  URL_ADD_DOCUMENT: environment.url_api +  'Trip2Driver/RegisterDocument',
  URL_GET_LICENSES: environment.url_api +  'Trip2Driver/Licenses',
  URL_GET_VEHICLE_LICENSES: environment.url_api +  'Trip2Driver/LicensesVehicle',
  URL_GET_LICENSE_TYPES: environment.url_api +  'Trip2Driver/TypeLicenses',
  URL_ADD_LICENSE: environment.url_api +  'Trip2Driver/RegisterLicense',
  URL_DRIVER_HISTORY: environment.url_api +  'Trip2Driver/History',
  URL_GET_VLICENSE_TYPES: environment.url_api +  'Trip2Driver/TypeLicensesVehicle',
  URL_SEND_MESSSAGE: environment.url_api +  'MCTDriver/SendMessageToUsers',
  URL_SEND_MESSSAGE_TO_PROVIDERS: environment.url_api +  'Company/SendMessageToProviders',
  URL_DRIVER_DEVICE: environment.url_api + 'UserDevice/SearchByUser',
  URL_VERIFY_LICENSE_ON_DEMAND_DRIVER: environment.url_api + 'Trip2Driver/VerifyLicense',
  URL_REACTIVE_ACCOUNT_ON_DEMAND_DRIVER: environment.url_api + 'Trip2Driver/ReactivateAccount',
  /**
   * PROVIDER DOCUMENTS ENDPOINT
   */
  URL_PROVIDER_DOCUMENT: environment.url_api +  'ProviderDocument',
  /**
   * FAX ENDPOINT
   */
  URL_GET_FAXES: environment.url_api +  'FaxRequest',
  URL_MARK_ERROR_FAX: environment.url_api + 'FaxRequest/ChangeStatus',
  URL_POST_SEND_FAX: environment.url_api + 'FaxRequest/SendEmail',
  URL_GET_TRIPS_BY_FAXID: environment.url_api + 'FaxRequest/GetTripsById',

  /**
   * @description RIDER ENDPOINT
   */
  RIDER: {
    BASE: environment.url_api + 'Rider',
    RIDER_PAYOR: {
      BASE: environment.url_api + 'RiderPayor/',
      GET: environment.url_api + 'RiderPayor?riderId=',
      POST: environment.url_api + 'RiderPayor/Create',
      PUT: environment.url_api + 'RiderPayor/Update',
    },
    RIDER_PAYOR_DETAIL: {
      BASE: environment.url_api + 'RiderPayorDetail/',
      DELETE_RIDER_PAYOR: environment.url_api + 'RiderPayorDetail/Delete',
      GET_BY_RIDER_PAYOR: environment.url_api + 'RiderPayorDetail/RiderPayor/'
    }
  },

  /**
   * @description PLAN ENDPOINT
   */
  PLAN: {
    BASE: environment.url_api + 'Plan',
    LISTACTIVEPLANSINPAYOR: environment.url_api + 'Plan/ListActivePlansInPayor',
    URL_PLAN_TYPES: environment.url_api + 'Plan/PlanTypes',
    URL_SET_RESERVATION_PLAN_TYPE_AND_REGION: environment.url_api + 'PlanHeader/SetReservationPlanTypeAndRegion'
  },
  /**
   * @description DRIVER ENDPOINT
   */
  DRIVER: {
    MCT_DRIVER : {
      BASE: environment.url_api + 'MCTDriver',
      LIST_BY_FILTER: environment.url_api + 'MCTDriver/ListByFilter/',
      DRIVER_SCHEDULE: environment.url_api + 'MCTDriver/GetDriverSchedule',
      UPDATE_DRIVER_SCHEDULE: environment.url_api + 'MCTDriver/UpdateDriverSchedule'
    },
    DRIVER_LICENSE: {
      EXTRACT_LICENSE_NUMBER_FROM_IMAGE: environment.url_api + 'DriverLicense/ExtractDriverLicense',
    }
  },
  /**
   * @description DEPOT ENDPOINT
   */
  DEPOT: {
    BASE: environment.url_api + 'Depot',
    LIST_BY_PROVIDER: environment.url_api + 'Depot/ListByProvider/',
  },

  /**
   * RIDERS ENDPOINT
   */
  URL_RIDER: environment.url_api +  'Rider',
  URL_RIDER_QR: environment.url_api +  'Rider/QrCode',
  URL_RIDER_CODE: environment.url_api +  'Rider/Code',
  URL_RIDER_PAYOR_DETAIL: environment.url_api +  'Rider/RiderPayorDetail',
  URL_RIDER_ADMIN_USER: environment.url_api + 'Rider/AdminUserByRider',
  URL_RIDER_PAYOR: environment.url_api +  'RiderPayor/DefaultPayor/',
  URL_TRIP_HISTORY_RIDER: environment.url_api +  'Trip/TripHistory/',
  URL_TRIP_LIST_BY_RIDER: environment.url_api +  'Trip/ListByRider',
  URL_ADD_RIDER_HISTORY: environment.url_api +  'RiderHistory/Attach',
  URL_GET_RIDER_HISTORY: environment.url_api + 'RiderHistory/List/',
  URL_UPDATE_SIGNATURE: environment.url_api + 'Signature/UpdateSignature',
  URL_RESET_SIGNATURE_BY_ID: environment.url_api + 'Signature/ResetSignatureById/',
  URL_GET_SIGNATURES_BY_RIDER: environment.url_api + 'Signature/GetSignaturesByRiderId/',
  URL_RIDER_VERIFY_EMAIL: environment.url_api + 'Rider/VerifyEmail',
  URL_RIDER_SEND_VERIFY_EMAIL: environment.url_api + 'Rider/SendVerifyEmail',
  /**
   * RESCUENET INTEGRATION ENDPOINT
   */
  URL_RESCUENET_RIDER_SEARCH: environment.url_api + 'Integration/RescueNet/Riders/search',
  URL_RESCUENET_RIDER: environment.url_api + 'Integration/RescueNet/Riders',
  URL_RESCUENET_RESERVATION_LOOKUP: environment.url_api + 'Integration/RescueNet/Reservations',
  URL_RESCUENET_JOB_LOOKUP: environment.url_api + 'Integration/RescueNet/Reservations/job',
  URL_RESCUENET_TRIP: environment.url_api + 'Integration/RescueNet/Trips',
  URL_RESCUENET_CALL_TYPES: environment.url_api + 'Integration/RescueNet/Catalogs/CallTypes',
  URL_RESCUENET_PRIORITIES: environment.url_api + 'Integration/RescueNet/Catalogs/Priorities',
  URL_RESCUENET_TRANSPORT_REASONS: environment.url_api + 'Integration/RescueNet/Catalogs/TransportReasons',
  URL_RESCUENET_ZONES: environment.url_api + 'Integration/RescueNet/Catalogs/Zones',
  URL_RESCUENET_NATURES: environment.url_api + 'Integration/RescueNet/Catalogs/NatureOfCalls',
  URL_RESCUENET_COMPANIES: environment.url_api + 'Integration/RescueNet/Companies',
  URL_RESCUENET_PAYORS: environment.url_api + 'Integration/RescueNet/Payors',
  URL_RESCUENET_DOCTORS: environment.url_api + 'Integration/RescueNet/Doctors',
  URL_RESCUENET_FACILITIES: environment.url_api + 'Integration/RescueNet/Facilities',
  URL_RESCUENET_FACILITY_DEPARTMENTS: environment.url_api + 'Integration/RescueNet/Facilities',
  /**
   * FACILITIES ENDPOINT
   */
  URL_FACILITY: environment.url_api +  'Facility',
  URL_GET_FACILITIES_NEW: environment.url_api +  'Facility/ListAll?filter=',
  URL_PAYOR_FACILITY: environment.url_api +  'Facility/ListByPayor?payorId=',
  URL_GET_FACILITIES: environment.url_api +  'Facility/List?filter=',
  URL_PAYOR_FACILITY_2: environment.url_api +  'PayorFacility/ListByPayor/',
  /**
   * PAYOR FACILITIES
   */
  URL_PAYOR_FACILITIES: environment.url_api +  'PayorFacility',
  /**
   * FACILITY TYPES ENDPOINT
   */
  URL_FACILITY_TYPE: environment.url_api +  'FacilityType',
  URL_FACILITY_TYPE_LIST: environment.url_api +  'FacilityType/List',
  /**
   * MODIFIERS ENDPOINT
   */
  URL_CREATE_MODIFIER: environment.url_api +  'Facility/CreateModifier',
  URL_UPDATE_MODIFIER: environment.url_api +  'Facility/UpdateModifier',
  URL_DELETE_MODIFIER: environment.url_api +  'Facility/DeleteModifier',
  URL_MODIFIERS: environment.url_api +  'Facility/ListModifier',
  URL_MODIFIER_BY_ID: environment.url_api +  'Facility/ModifierById',
  /**
   * PAYOR MODULES ENDPOINT
   */
  URL_PAYOR_TYPE: environment.url_api +  'PayorType',
  URL_PAYOR: environment.url_api +  'Payor',
  URL_CHARGES: environment.url_api +  'Charge',
  URL_FORM: environment.url_api +  'Form',
  URL_EXPORT_FORM_LIST: `${environment.url_api}Form/List`,
  URL_EVENT: environment.url_api +  'Event',
  URL_CREDIT_TYPE: environment.url_api +  'CreditType',
  URL_CREDIT: environment.url_api +  'Credit',
  URL_DENIAL_REASONS: environment.url_api +  'Denial',
  URL_PAYOR_PLAN: environment.url_api +  'Plan',
  URL_PAYOR_PLANS: environment.url_api +  'Plan/List',
  URL_RATE: environment.url_api +  'Rate',
  URL_BANKS: environment.url_api + 'Bank',
  URL_PAYOR_GEOFENSE_LIST: environment.url_api + 'PayorGeofence/List/',
  URL_PAYOR_GEOFENSE: environment.url_api + 'PayorGeofence',
  URL_PAYOR_HISTORY: environment.url_api + 'PayorHistory/',
  URL_PAYOR_USERS: environment.url_api + 'Payor/users/',
  URL_DENIAL_CODE: environment.url_api + 'Denial/listAll',
  URL_ADD_DENIAL_CODE: environment.url_api + 'Denial',
  URL_ADD_DENIAL_CATEGORIES_CODE: environment.url_api + 'Denial/GetCategories',
  URL_ADD_DENIAL_CATEGORY: environment.url_api + 'Denial/AddCategory',
  URL_ADD_DENIAL_CATEGORIZE_DENIAL_TRIP : environment.url_api + 'Denial/CategorizeDenialTrip',
  URL_ADD_DENIAL_ASSIGN_MASSIVE_CATEGORY_TRIP : environment.url_api + 'Denial/AutoAssignDenialCategory',
  URL_PAYOR_ENCOUNTERTYPE: environment.url_api + 'Payor/EncounterType',

  /**
   * EDIT BILLING
   */
  URL_CHARGES_FOR_SELECT: environment.url_api + 'Charge?tripId=',
  URL_TRIPS_TO_EXPORT_BILLING: environment.url_api + 'Invoice/TripsToExportBillingForm',
  URL_FORM_OF_TRIPS: environment.url_api + 'Invoice',
  URL_BILLING: {
    TRIP_CHARGE: {
      BASE: environment.url_api + 'TripCharge',
      CHANGE_PROVIDER_BILLING: environment.url_api + 'TripCharge/ChangeProviderBilling',
      CHANGE_PROVIDER_BILLING_SO: environment.url_api + 'StandingOrder/ChangeProviderBilling',
      CHANGE_CLIENT_BILLING: environment.url_api + 'TripCharge/ChangeClientBilling',
      CHANGE_CLIENT_BILLING_SO: environment.url_api + 'StandingOrder/ChangeClientBilling',
      IS_NEGOTIATED_RATE_TRIP: environment.url_api + 'TripCharge/IsNegotiatedRateTrip',
      CHANGE_TIME_SO: environment.url_api + 'StandingOrder/ChangeTimeAndNotes',
      IS_DUPLICATE_TRIP: environment.url_api + 'TripCharge/NotDuplicate',
      NON_NEGOTIABLE_TRIP: environment.url_api + 'TripCharge/NonNegotiable'
    },
    TRIP_CREDITS: {
      BASE: environment.url_api + 'TripCredit',
    },
  },

  /**
   * CANCEL REASONS ENDPOINT
   */
  URL_CANCEL_REASONS: environment.url_api + 'TripCancelReason/',
  URL_CANCEL_REASONS_HISTORY: environment.url_api + 'TripCancelReason/GetHistoryCancelReason',
  /**
   * BILLING ENDPOINT
   */
  URL_BILLING_SCHEDULE: environment.url_api +  'BillingSchedule',
  URL_BILLING_SCHEDULE_LIST: environment.url_api +  'BillingSchedule/List',
  URL_BILLING_SCHEDULE_UPDATE_AGING: environment.url_api +  'BillingSchedule/UpdateAging',
  URL_BILLING_SCHEDULE_PAYORS: environment.url_api +  'BillingSchedule/RiderPayor?riderid=',
  URL_BILLING_SCHEDULE_EDIT: environment.url_api +  'BillingSchedule/UpdateBillingScheduleTrip',
  URL_BILLING_SCHEDULE_DETAIL: environment.url_api +  'BillingScheduleDetail/BillingSchedule',
  URL_BILLING_SCHEDULE_DETAIL_2: environment.url_api +  'BillingScheduleDetail',
  URL_NEXT_BILLING_SCHEDULE: environment.url_api +  'BillingSchedule/ListDifferentThisId',
  URL_GET_CHARGES_TOTAL: environment.url_api +  'FeeSchedule/getChargesTotal',
  URL_BILL_PATIENT: environment.url_api +  'Payor/BillPatient',
  URL_PAYOR_LIST: environment.url_api +  'Payor/List',
  URL_BILLING_BY_RANGE: environment.url_api +  'Trip/List',
  URL_EPCR_LIST: environment.url_api + 'Epcr/List',
  URL_EPCR_DETAIL: environment.url_api + 'Epcr/Detail/',
  URL_EPCR_REPORT_SUMMARY: environment.url_api + 'Epcr/ReportSummary',
  URL_EPCR_PAYORS: environment.url_api + 'Epcr/Payors',
  URL_EPCR_PAYOR_TYPES: environment.url_api + 'Epcr/PayorTypes',
  URL_EPCR_ASSIGNMENT_USERS: environment.url_api + 'Epcr/AssignmentUsers',
  URL_EPCR_TAB_USERS: environment.url_api + 'Epcr/TabUsers',
  URL_EPCR_ASSIGN: environment.url_api + 'Epcr/Assign',
  URL_EPCR_UNASSIGN: environment.url_api + 'Epcr/Unassign',
  URL_CALC_MRS_AMOUNT: environment.url_api + 'Payor/CalcMrsAmount/',
  URL_LOAD_TRIPS_BY_ID: environment.url_api + 'Trip/TripsToExportByTripId',
  URL_PAYOR_LIST_BY_TYPEID: environment.url_api +  'Payor/List?payorTypeId=',
  URL_BILLING_STATUS: environment.url_api + 'Export/BillingStatus',
  URL_BILLING_SUMMARY: environment.url_api + 'Trip/SummaryBilledClient',
  URL_INACTIVE_PAYORS: environment.url_api +  'Payor/List?showInactive=',
  URL_MASS_MOVEMENT: environment.url_api + 'Trip/TripToMassMovementBilling',
  URL_MASS_MOVEMENT_BILLING: environment.url_api +  'BillingSchedule/TripToMassMovementBilling',
  URL_BILLING_STATUS_DENIAL: environment.url_api +  'TripCredit/BillingStatusDenial',
  URL_BILLING_CLAIM_TRIPS_SUMMARY: environment.url_api +  'Claim/SummaryBillingClaimTrips',

  /**
   * TRIPS ENDPOINT
   */
  URL_TRIP_SEARCH_TRIP_TODAY: environment.url_api +  'Trip/TodayTripsForReservation/',
  URL_TRIP_SEARCH: environment.url_api +  'Trip',
  URL_TRIP_TO_CONFIRM: environment.url_api +  'Trip/TripConfirm',
  URL_MASSIVE_TRIP_TO_CONFIRM: environment.url_api +  'Trip/MassiveChangeTripConfirm',
  URL_TRIP_FACILITIES: environment.url_api +  'Facility/ListAll?filter=',
  URL_TRIP_HISTORY: environment.url_api +  'Trip/TripHistory/',
  URL_TRIP_SEARCH_BY_ID: environment.url_api +  'Trip/SearchById/',
  URL_TRIP_STATUS: environment.url_api +  'Trip/TripStatus/',
  URL_TRIP_HISTORY_ATTACH: environment.url_api +  'Trip/AttachFileToTripHistory/',
  URL_TRIP_STANDING_ORDER: environment.url_api +  'StandingOrder/',
  URL_TRIP_STANDING_ORDER_PUT: environment.url_api +  'Trip/StandingOrderUpdate/',
  URL_TRIP_STANDING_ORDER_BY_RIDER: environment.url_api +  'StandingOrder/Search?riderid=',
  URL_TRIP_STANDING_ORDER_BY_ID: environment.url_api +  'Trip/StandingOrderById/',
  URL_TRIP_ACTIVATE: environment.url_api +  'Trip/ActivateTrips',
  URL_TRIP_DATE_VALIDATE: environment.url_api +  'Trip/ValidateTripsByDate',
  URL_TRIPS_CHANGE_STATUS: environment.url_api +  'Trip/ChangeTripsStatus',
  URL_TRIPS_REGISTERS: environment.url_api +  'Trip/RegisterTrips',
  URL_ADVANCE_SEARCH: environment.url_api +  'Rider/AdvanceSearch ',
  URL_POST_NEW_SO: environment.url_api +  'StandingOrder',
  URL_LEGS_BY_TRIP: environment.url_api +  'Trip/ListByReservation',
  URL_SYNC_TRIPS: environment.url_api + 'Integration/SendTripNemt',
  URL_SEND_TRIPS_TO_MCT: environment.url_api + 'Integration/SendTripToOrigin',
  URL_TRIPS_ESCALATION: environment.url_api  + 'Trip/EscalationTrips',
  URL_CHANGE_BILLING_STATUS: environment.url_api + 'Export/ChangeBillingStatus',
  URL_ADVANCE_SEARCH_BY_CLAIM: environment.url_api + 'Trip/Claim',
  URL_SEARCH: environment.url_api + 'Search',
  URL_TRIP_STATUS_BY_STATU: environment.url_api + 'TripStatus/NextStatusesByStatus',
  URL_TRIP_STATUS_BY_TRIP: environment.url_api + 'TripStatus/NextStatusesBytrip',
  URL_TRIP_VIP_LIST: environment.url_api + 'TripVip/List',
  URL_TRIP_VIP: environment.url_api +  'TripVip',
  URL_TRIP_VIP_SAVE: environment.url_api +  'TripVip/Save',
  URL_GOOGLE_ODRD_GUID: environment.url_api + 'Trip/googleOdrdGuid',
  URL_NEXTSTATUS_TRIPS: environment.url_api + 'TripStatus/NextStatuses',
  URL_COUNT_LEGS_RESERVATION: environment.url_api + 'Trip/CountLegsReservation/',
  URL_TRIP_STANDING_ORDER_GET_BY_DATE: environment.url_api +  'StandingOrder/GetStandingOrderByDate',
  URL_TRIP_CHANGETRIPSCOMPANY: environment.url_api + 'Trip/ChangeTripsCompany',
  URL_TRIP_DOWNLOAD_BILLING_REPORT: environment.url_api + 'Trip/GenerateBillingReport',
  URL_TRIP_PAYMENT_RECEIPT_BY_TRIP_ID: environment.url_api + 'TripPaymentReceipt/GetByTripId',
  URL_TRIP_PAYMENT_RECEIPT_UPLOAD: environment.url_api + 'TripPaymentReceipt',
  /**
   * Standing order lock
   */

   URL_LOCK_SO: environment.url_api + 'StandingOrder/',
  /**
   * DISTANCE MATRIX AND TRIP LOCATION
   */
  URL_DISTANCE_MATRIX: environment.url_api +  'Trip/DistanceMatrix',
  URL_TRIP_LOCATION: environment.url_api + 'Trip/location',
  URL_GET_LOCATION_MAPBOX_GOOGLE: environment.url_api + 'Location/LocationPlaces',
  URL_GET_ESTIMATED_PU: environment.url_api +  'TimeRule/TimeRule/?',
  /**
   * DATE TIME SERVICE
   */
  URL_DATE_TIME_NOW: environment.url_api +  'Trip/DateTimeNow/',
  /**
   * FEE SCHEDULE
   */
  URL_FEE_SCHEDULE: environment.url_api +  'FeeSchedule',
  /**
   * PROVIDER FEE SCHEDULE ENDPOINT
   */
  URL_PROVIDER_FEE_SCHEDULE: environment.url_api +  'ProviderFeeSchedule',
  /**
   * PROVIDER RATE ENDPOINT
   */
  URL_PROVIDER_RATE: environment.url_api +  'ProviderRate',
  /**
   * CANCEL REASON ENDPOINT
   */
  URL_CANCEL_REASON: environment.url_api +  'Trip/TripCancelReason',
  /**
   * CHANGE STANDING ORDER STATUS ENDPOINT
   */
  URL_CHANGE_SO_STATUS: environment.url_api +  'Trip/ChangeStandingOrderStatus',
  URL_CHANGE_STATUS_SO: environment.url_api +  'StandingOrder',
  /**
   * LIVE MAP ENDPOINT
   */

  URL_HUB_VEHICLE_LIVE_MAP: environment.url_api +  'Vehicle/LiveMap/',
  URL_HUB_FAX: environment.url_api +  'Hub/FaxGroup/',
  URL_DRIVER_INFO_T2_LIVE_MAP: environment.url_api +  'Trip2Driver/',
  URL_DRIVER_INFO_MCT_LIVE_MAP: environment.url_api +  'MCTdriver/',
  URL_RIDER_INFO_LIVE_MAP: environment.url_api +  'Rider/',
  URL_RIDER_INFO_MAP: environment.url_api +  'Vehicle/RiderInformationMap/',
  URL_GET_TRIP_LOCATION: environment.url_api +  'Trip2Driver/DriverLocation/',
  URL_GET_TRIP_ROUTE: environment.url_api +  'Trip2Driver/Route/',
  URL_GET_TRIP_LIST: environment.url_api +  'Trip/List',
  URL_GET_ACTIVE_TRIPS: environment.url_api +  'Trip/RidersLiveMap',
  URL_GET_ACTIVE_VEHICLES: environment.url_api +  'Trip/DriversLiveMap',
  URL_GET_ACTIVE_TRIPS_BY_PROVIDER: environment.url_api +  'Trip/ActiveTrips',
  URL_GET_LATE_TRIPS_BY_PROVIDER: environment.url_api + 'TripHub',
  /**
   * SIGNAL R RESERVATION
   */
  URL_HUB_SERVICE_LIVE_MAP: environment.url_api +  'hub/DispatchGroup/',
  URL_HUB_SERVICE_SCHEDULING: environment.url_api +  'Hub/ShedulingGroup/',
  URL_HUB_SERVICE_DISPATCH: environment.url_api +  'Hub/DispatchGroup/',
  URL_HUB_EDIT_RESERVATION: environment.url_api +  'Hub/TripChanges/',
  URL_HUB_DISPATCH_GROUP: environment.url_api +  'Hub/DispatchGroup/',
  URL_ADD_PROVIDER_ASSIGNMENT_DATE: environment.url_api +  'UserConnectionModule',
  URL_HUB_AUTOROUTING_JOBS: environment.url_api + 'Hub/AutoRoutingGroup/',
  URL_HUB_DRIVER_LOCATION: environment.url_api + 'Hub/DriverLocation/',
  URL_HUB_DISPATCH_GROUP_BY_DATE: environment.url_api + 'Hub/DispatchGroupByDate/',
  URL_HUB_TRIP_GROUP: environment.url_api + 'Hub/TripGroup/',
  URL_HUB_ACTIVE_TRIPS: environment.url_api + 'Hub/ActiveTrips/',
  URL_HUB_LAST_TRIPS: environment.url_api + 'Hub/LateTrip',
  URL_HUB_LIVE_TRIP: environment.url_api + 'Hub/LiveTrip/',
  URL_HUB_TRIP_STATUS_CHANGES: environment.url_api + 'Hub/TripStatusChanges/',

  /**
   * SESSION ENDPOINT
   */
  URL_SESSION: environment.url_api +  'Session',
  URL_REMEMBER_PASSWORD: environment.url_api +  'UserProfile/ForgotPassword',
  URL_VERIFY_TOKEN: environment.url_api +  'Session/ValidateToken/',
  URL_FAX_REQUEST: environment.url_api +  'FaxRequest',

  URL_SESSION_GET_TOKEN: environment.url_api + 'Configuration/SearchByDescription/ApiKeyProvider',
  URL_PROVIDER_SESSION: environment.url_api + 'Session/ProviderApiKey/',

  /**
   * PATTERNS
   */
  NO_BLANK_SPACE: /\S+/,

  /***
   * MASK DEFINITIONS
   */
  MASK_DL: [/[a-zA-Z]/, /[0-9]/, /[0-9]/, /[0-9]/, '-',
    /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/],
  MASK_PHONE: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  MASK_SSN: [/[0-9]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
  MASK_ZIPCODE: [/[1-9]/, /\d/, /\d/, /\d/, /\d/],
  MASK_DECIMAL: [/[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/],
  MASK_DATE_DMY: [/[0-1]/, /[0-9]/, '-', /[0-3]/, /[0-9]/, '-', /[1-2]/, /[0-9]/, /[0-9]/, /[0-9]/],
  MASK_MI: [/[a-zA-Z]/],
  MASK_TIME: [/[0-2]/, /[0-9]/, ':', /[0-5]/, /[0-9]/],
  MASK_DATE: [/[1-2]/, /[0-9]/, /[0-9]/, /[0-9]/ , '-', /[0-1]/, /[0-9]/ , '-', /[0-3]/, /[0-9]/],
  MASK_DOB: [/[0-1]/, /[0-9]/ , '-', /[0-3]/, /[0-9]/, '-' , /[1-2]/, /[0-9]/, /[0-9]/, /[0-9]/],
  MASK_DATE_TIME: [/[1-2]/, /[0-9]/, /[0-9]/, /[0-9]/ , '-', /[0-1]/, /[0-9]/ , '-', /[0-3]/, /[0-9]/, ' ', /[0-2]/, /[0-9]/, ':',
    /[0-5]/, /[0-9]/],
  MASK_SSN_DRIVER: [
    /[0-9a-zA-Z]/, /[0-9a-zA-Z]/, /[0-9a-zA-Z]/, '-',
    /[0-9a-zA-Z]/, /[0-9a-zA-Z]/, '-',
    /[0-9a-zA-Z]/, /[0-9a-zA-Z]/, /[0-9a-zA-Z]/, /[0-9a-zA-Z]/
  ],
  MASK_STATE: [/\D/, /\D/],
  MASK_PHONE2: '(999) 999-9999',
  MASK_TIMES: 'Hh:Mm',
  MASK_DATES: {
    DDMMYYYY: '99-99-9999',
  },
  MASKS: {
    DATES: {
      DDMMYYYY: '99-99-9999',
    },
    PHONES: {
      DEFAULT: '(999) 999-9999',
      PLUS_ONE: '+9 (999) 999-9999',
      DEFAULT_ONDEMAND: '+9 (999) 999 - 9999'
    },
    ZIPCODE: '99999',
  },
  PATTERNS: {
    DATE: '^\\s*(3[01]|[12][0-9]|0?[1-9])\\-(1[012]|0?[1-9])\\-((?:19|20)\\d{2})\\s*$',
    DECIMAL: '^\\d*(\\.\\d{0,2})?$'
  },

  /** Ranges Dates**/
  RANGES_DATES: [
    {description: 'Custom', type: 0},
    {description: 'Yesterday', type: 1},
    {description: 'Day Before Yesterday', type: 2},
    {description: 'Today', type: 3},
    {description: 'Tomorrow', type: 4},
    {description: 'Day After Tomorrow', type: 5},
    {description: 'Last Full Week', type: 6},
    {description: 'Last Full Month', type: 7},
    {description: 'Last 7 Days', type: 8},
    {description: 'Week to Date From Sunday', type: 9},
    {description: 'Month to Date', type: 10},
    {description: 'Year to Date', type: 11},
    {description: 'Calendar 1st Quarter', type: 12},
    {description: 'Calendar 2nd Quarter', type: 13},
    {description: 'Calendar 3rd Quarter', type: 14},
    {description: 'Calendar 4th Quarter', type: 15},
    {description: 'Calendar 1st Half', type: 16},
    {description: 'Calendar 2nd Half', type: 17},
    {description: 'Last Year MTD', type: 18},
    {description: 'Last Year YTD', type: 19},
    {description: 'Billing Go Live Date', type: 20},
    {description: 'Dispatch Go Live Date', type: 21},
    {description: 'Entire Database', type: 22},
  ],
  /**
   *
   */
  URL_IMPORT_FCC: environment.url_api +  'FccTrackingNumber',
  URL_IMPORT_PRE_POSTING: environment.url_api +  'PrePosting',

  // ====================== Deposits ====================================
  URL_API_DEPOSIT_STATUS: environment.url_api + 'Deposit/DepositStatus',
  URL_API_DEPOSIT_SEARCH: environment.url_api + 'Deposit/Deposit/Search',
  URL_API_DEPOSIT_ALLEGED: environment.url_api + 'Deposit/AllegedDepositDetails',
  URL_API_DEPOSIT_BASE: environment.url_api + 'Deposit',
  URL_API_DEPOSIT_DISTINCT_ACCOUNT: environment.url_api + 'Deposit/DistinctBankAccounts',
  URL_API_DEPOSIT_BANK_ACCOUNT: environment.url_api + 'Deposit/BankAccount',
  URL_API_DEPOSIT_UPLOAD_FILE: environment.url_api + 'Deposit/importFile',
  URL_API_DEPOSIT_ACCOUNT_SUMMARY_REPORT: environment.url_api + 'Deposit/AccountSummaryReport',
  URL_API_DEPOSIT_HISTORY: environment.url_api + 'Deposit/History',
  URL_API_DEPOSIT_GET_DETAIL: environment.url_api + 'Deposit/MatchedWithGroupedPostedByDepositId',
  URL_API_DEPOSIT_DETAIL_SAVE: environment.url_api + 'Deposit/DepositDetail',
  URL_API_DEPOSIT_DETAIL_DELETE_ALL: environment.url_api + 'Deposit/DepositDetail/DeleteAll',
  URL_API_DEPOSIT_DETAIL_CREATE_MASSIVE: environment.url_api + 'Deposit/DepositDetail/Massive',
  URL_API_DEPOSIT_GROUPED_BY_CHECKNUMBER: environment.url_api + 'Deposit/GroupedByCheckNumber',
  URL_API_DEPOSIT_POSTED_DISTINCT_PAYORS: environment.url_api + 'Deposit/DistinctPayors',
  URL_API_DEPOSIT_REFRESH_DETAIL_PAYORS: environment.url_api + 'Deposit/RefreshDetailsPayors',
  URL_API_DEPOSIT_GET_PO_BOX: environment.url_api + 'Deposit/GetPoBox',
  URL_API_DEPOSIT_GET_OFFICE_DEPOSIT_DESCRIPTION: environment.url_api + 'Deposit/OfficeDepositDescriptionList',
  // ====================================================================
  MODAL_DEPOSITS: {
    Deposits: ModalNameEnum.Deposits,
    ImportFile: ModalNameEnum.ImportFile,
    CopyPasteDepositDetails: ModalNameEnum.CopyPasteDepositDetails,
    NoteDetails: ModalNameEnum.NoteDetails,
    HistoryDetails: ModalNameEnum.HistoryDetails,
  },
  STEPPER_DEPOSITS: {
    Start: StepperEnum.Start,
    Previous: StepperEnum.Previous,
    Next: StepperEnum.Next,
    End: StepperEnum.End
  },

  // ====================== LockBox ======================================
  URL_API_DEPOSIT_LOCKBOX_SEARCH: environment.url_api + 'LockBox/LogBox/Search',
  URL_API_DEPOSIT_LOCKBOX_UPDATE: environment.url_api + 'LockBox',
  // =====================================================================

  // ====================== Office Deposit ======================================
  URL_API_DEPOSIT_OFFICE_DEPOSIT_SEARCH: environment.url_api + 'OfficeDeposit/Search',
  URL_API_DEPOSIT_OFFICE_DEPOSIT_BASE: environment.url_api + 'OfficeDeposit',
  URL_API_DEPOSIT_OFFICE_DEPOSIT_MASSIVE: environment.url_api + 'OfficeDeposit/massive',
  URL_API_DEPOSIT_OFFICE_DEPOSIT_OFFICE_DEP_GROUPED: environment.url_api + 'OfficeDeposit/OfficeDepositGrouped',
  URL_API_DEPOSIT_OFFICE_DEPOSIT_UPDATE_STATUS: environment.url_api + 'OfficeDeposit/UpdateOfficeDepositStatus',
  // =====================================================================

  // ======================= Electronic =================================
  URL_ELECTRONICT: environment.url_api + 'Electronic',
  URL_ELECTRONIC_SEARCH: environment.url_api + 'Electronic/Search',
  URL_ELECTRONIC_GET_DETAIL_BY_ID: environment.url_api + 'Electronic/GetElectronicDetailById',
  URL_ELECTRONIC_GET_REMIT_SUMMARY_BY_ID: environment.url_api + 'Electronic/GetRemitSummaryById',
  URL_ELECTRONIC_GET_CLAIM_DETAIL_BY_ID: environment.url_api + 'Electronic/GetClaimDetailById',
  URL_ELECTRONIC_DELETE_BY_ID: environment.url_api + 'Electronic/DeleteElectronicById',

  // ====================== Posted ======================================
  URL_API_DEPOSIT_POSTED_SEARCH: environment.url_api + 'Posted/Search',
  URL_API_DEPOSIT_POSTED_BASE: environment.url_api + 'Posted',
  URL_API_DEPOSIT_POSTED_UPDATE_LOCKBOX_STATUS: environment.url_api + 'Posted/UpdateLockBoxStatus',
  URL_API_DEPOSIT_POSTED_COPY: environment.url_api + 'Posted/Copy',
  URL_API_DEPOSIT_POSTED_WITHOUT_DEPOSIT: environment.url_api + 'Posted/PostedWithoutDeposit',
  // =====================================================================

  URL_IMPORT_PAYOR: environment.url_api +  'ImportFile/',
  URL_IMPORT_PAYOR_FILE: environment.url_api + 'ImportFile/Import/',
  URL_IMPORT_FILE_835: environment.url_api + 'EdiFile/835P',
  URL_IMPORT_PAYOR_READFILE: environment.url_api + 'ImportFile/ReadFile',
  URL_EXPORT_TRIPS: environment.url_api +  'Trip/TripsToExport',
  URL_FORMEXPORT_TRIPS: environment.url_api +  'FormExport/Trips',
  URL_VERIFY_TRIPS: environment.url_api +  'Export/Verified',
  URL_CHANGE_BILLING_STATUS_TRIP: environment.url_api +  'Trip/ChangeBillingStatus',
  URL_EXPORT_TO_ZOLLDATA: environment.url_api +  'Export/ExportTrips',
  URL_ERRORS_BY_TRIPID: environment.url_api +  'Trip/ErrorsByTripId',
  URL_FORMEXPORT_SETNONDUPLICATE_TRIPS: environment.url_api +  'FormExport/SetNonDuplicate',
  URL_FORMEXPORT_CHANGE_PLANTYPE: environment.url_api +  'FormExport/ChangePlanType',
  URL_FORMEXPORT_SETMODIFIER_TRIPS: environment.url_api +  'FormExport/SetModifier',
  URL_IMPORT_TRIPS_FROM_UBER: environment.url_api + 'ImportFile/ImportTripsFromUber',
  URL_FORMEXPORT_GET_ENCOUNTERHISTORY: environment.url_api +  'FormExport/GetHistoryEdiFile',
  URL_FORMEXPORT_DOWNLOADFILE_BYINVOICEBATCH: environment.url_api + 'FormExport/DownloadFileByInvoiceBatch',

  URL_REASON_SIGN: environment.url_api +  'MCTDriver/TripReasonSign',
  URL_REASON_TRANSPORT: environment.url_api +  'Trip/TripReasonTransport',
  URL_SIMPLY_REASON_TRANSPORT: environment.url_api +  'TripReasonTransport/getSimplyReasonTransport',
  URL_REASON_TRANSPORT_LIST: environment.url_api +  'TripReasonTransport/ListByPayor',
  URL_PAYOR_REASON_TRANSPORT: environment.url_api +  'TripReasonTransport',
  URL_REASON_TRANSPORT_HISTORY: environment.url_api +  'TripReasonTransport/GetHistoryTripReasonTransport',
  URL_TRIP_NOTES: environment.url_api +  'TripNote',
  URL_RIDER_NOTES: environment.url_api +  'RiderNote',
  URL_USER_PROFILE_ALL: environment.url_api +  'UserProfile/listAll',
  URL_GET_RIDER_PAYORS: environment.url_api +  'RiderPayor?riderid=',
  URL_DRIVER_NOTES: environment.url_api + 'DriverNote',
  URL_COMPLAINT_HISTORY_SEARCH_BY_NOTE: environment.url_api +  'ComplaintHistory/SearchByNote/',
  URL_TRIP_NOTES_TEMPLATE_BASE: environment.url_api +  'TripNoteTemplate',

  /**
   * EDIT RESERVATION BTN ENDPOINT
   * @type {string}
   */
  URL_EDIT_RESERVATION_BTN: environment.url_api + 'Trip2Driver/RegisterTripLog',
  URL_PUT_EDIT_RESERVATION_BTN: environment.url_api + 'Trip2Driver/UnLockTrips',
  URL_GET_TRIPLOCKS: environment.url_api + 'Trip2Driver/TripsLock',
  URL_SERVICE_STANDINGORDER: environment.url_api + 'StandingOrder',
  /**
   * MANIFEST ENDPOINT
   */
  URL_MANIFEST: environment.url_api + 'TripManifest',
  URL_LIST_TRIPS_BY_IDS: environment.url_api + 'Trip/TripsClaims',
  URL_MANIFEST_EXTRACT: environment.url_api + 'TripManifest/Extract',
  /**
   * DRIVER NOTES ENDPOINT
   */
  URL_EDIT_COMPANY: environment.url_api + 'Trip/ChangeTripCompany',
  URL_EDIT_COMPANY_STANDING_ORDER: environment.url_api + 'Trip/ChangeStandingOrderCompany',
  URL_EDIT_BROKER: environment.url_api + 'Trip/ChangeTripBroker',
  URL_EDIT_STATUS: environment.url_api + 'Trip/ChangeStatusTrip',
  URL_EDIT_VEHICLE_DRIVER: environment.url_api + 'Trip/ChangeTripDriverAndVehicle',
  URL_EDIT_VEHICLE_DRIVER_SO: environment.url_api + 'StandingOrder/ChangeVehicleDriver',
  URL_SURVEY_QUESTIONS: environment.url_api + 'Survey/Questions',
  URL_SURVEY: environment.url_api + 'Survey',
  URL_SURVEY_ANSWER: environment.url_api + 'Survey/Answers/',

  URL_VISITFORM: environment.url_api + 'visit',
  URL_LC_ACCESS_TOKEN: environment.url_api + 'LCIntegration/AccessToken',
  URL_LC_LOADTRIPS: environment.url_api + '',
  URL_LC_TRIPS: environment.url_api + 'Trip/TripsByPayor?payorId=',
  URL_LC_INTEGRATION: environment.url_api + 'LCIntegration/Trips',

  /***
   * PAYROLL ENDPOINT
   */
  URL_GET_PAYMENT_TRIPS: environment.url_api + 'TripPayment/Trips',
  URL_GET_PAYMENT_STATUS: environment.url_api + 'TripPayment/PaymentStatus',
  URL_GET_PAYMENT_DETAIL: environment.url_api + 'TripPayment/Detail',
  URL_PAYMENT: environment.url_api + 'TripPayment',
  URL_VALIDATE_MASSIVE_MANIFEST: environment.url_api + 'TripPayment/ValidateMassiveManifest',
  URL_PREPAID_PROCESS: environment.url_api + 'TripPayment/PrepaidProcess',
  URL_PAYMENT_CONFIRM: environment.url_api + 'TripPayment/Confirmation',
  URL_PAYMENT_RETURNS: environment.url_api + 'TripPayment/Returns',
  TTECH_ERRORS: environment.url_api + 'TTechErrors',
  URL_RECALC_PROVIDER_AMOUNT: environment.url_api + 'Trip/ProviderAmount',
  URL_PROV_PAYROLL: environment.url_api + 'Trip/ProvidersPayroll',
  URL_GET_EOB_PDF: environment.url_api + 'Report/CreateEobPdf',
  URL_GET_PROVIDERS: environment.url_api + 'Company/ListByParameter',
  URL_COUNT_BY_STATUS: environment.url_api + 'TripPayment/CountByStatus',

  /***
   * ANALITYCS
   */
  URL_T2DRIVERONLINE: environment.url_api +  'Trip2Driver/StatsTrip2Drivers',
  /**
   * MERGE ACCOUNT
   */
  URL_MERGE_ACCOUNT: environment.url_api +  'Rider/MergeRiders',
  /**
   * IVR
   * */
  URL_GET_IVR_TRIP: environment.url_api +  'Ivr/trip',
  URL_PUT_IVR_TRIP: environment.url_api +  'ivr/ConfirmTrip',
  URL_PUT_IVR_TRIP_UNSUBSCRIBE: environment.url_api +  'ivr/UnsubscribeEmail',
  URL_GET_IVR_CANCEL_TRIP: environment.url_api +  'ivr/cancelTrip',

  /**
   *	MCT MAP
   */
  URL_GET_TRIPS: environment.url_api +  '/MCTDriver/TodayTripsGrouped',
  /**
   *
   */
  URL_MAIL_TEMPLATES: environment.url_api +  'MailTemplate/',
  COUNTTRIPSBYSTATUS: environment.url_api +  'Trip/CountTripsByStatus',
  COUNTTRIPSBYCOMPANY: environment.url_api +  'Trip/CountTripsByCompany',
  RESTOREPASSWORD: environment.url_api +  'UserProfile/RestorePassword',
  CHANGE_PASSWORD: environment.url_api +  'UserProfile/ChangePassword',
  PROVIDERROLE_LIST_BY_ROLE: environment.url_api +  'ProviderRole/ListByRole/',
  PROVIDERROLE: environment.url_api +  'ProviderRole',
  PROVIDER_LIST_BY_DRIVER: environment.url_api +  'DriverProvider/ListByDriver/',
  PROVIDERDRIVER: environment.url_api +  'DriverProvider',
  PROVIDER_LIST_BY_VEHICLE: environment.url_api +  'VehicleProvider/ListByVehicle/',
  PROVIDERVEHICLE: environment.url_api +  'VehicleProvider',
  PROVIDER_ROLE_ACTIVE: environment.url_api +  'ProviderRole/ProvidersActive/',
  USER_TYPE: environment.url_api +  'UserType/',
  USER_PROVIDERS: environment.url_api +  'Company?showDisabled=false',
  EFT: environment.url_api +  'Company/ListByElectronicFoundTransfer',
  TRIP_SATUS: {
    active: 2,
    assigned: 3,
    pickup: 5,
    completed: 10,
    verify: 11,
    billed: 12,
    scheduled: 15,
    arrived: 16,
    on_my_way: 17,
  },
  CHANGE_PROVIDER_STATUS_TRIP_URL: environment.url_api +  'Trip/ChangeProviderStatus',
  CHANGE_PROVIDER_REROUTE: environment.url_api +  'Trip/ReRoute',
  REROUTE_REASON_LIST: environment.url_api +  'RerouteReason/RerouteReasonList',
  PROVIDERCOUNTRY: environment.url_api +  'ProviderCounty/ListByProvider/',
  GET_PROVIDER_COUNTRY: environment.url_api +  'ProviderCounty/Counties',
  GET_PROVIDER_AVAILABLE_COUNTIES: environment.url_api +  'ProviderCounty/CountiesAvailable',
  GET_PROVIDER_ZIP_CODES: environment.url_api +  'ProviderCountyZipCode/List',
  PROVIDERCOUNTRY_POST: environment.url_api +  'ProviderCounty',
  PROVIDERCOUNTRY_ZIP_CODES_POST: environment.url_api +  'ProviderCountyZipCode',
  URL_RESERVATION_ACTIONS: environment.url_api +  'ReservationAction',
  URL_LIST_MENU: environment.url_api +  'RoleAction/ListMenu/',
  URL_GET_PREVIOUS_ADDRESSES:   'Rider/TopLocations',
  /** URIS PARA EXCLUDE PROVIDER SERVICE
   */
  URL_EXCLUDE_PROV_LIST_BY_PAYOR: environment.url_api + 'PayorExcludeProvider/ListByPayor',
  URL_SAVE_EXCLUDE_PROV: environment.url_api + 'PayorExcludeProvider',
  URL_RECALC_EXPORT: environment.url_api + 'Trip/CalcTotalAmount',
  URL_EXCLUDE_PROV_LIST_BY_RIDER: environment.url_api + 'RiderExcludeProvider/ListRiderExcludeProviders',
  URL_SAVE_EXCLUDE_PROV_BY_RIDER: environment.url_api + 'RiderExcludeProvider/SaveRiderExcludeProviders',

  /** COMPLIANCE **/
  URL_COMPLIANCE:  environment.url_api + 'Compliance',
  URL_MESSAGE_PROVIDER: environment.url_api + 'Message/ByUser',
  /**
   * ROLES ENPOINT
   */
  URL_RULES: environment.url_api +  'VerificationRule',
  URL_RULES_BY_CODE: environment.url_api +  'RoleAction/SearchByModuleCode',
  URL_RULES_AVAILABLE_TO_PAYOR: environment.url_api +  'VerificationRule/AvailableToPayor',
  URL_RULES_PAYOR: environment.url_api +  'VerificationRulePayor',
  URL_RULES_BY_CODE_V2: environment.url_api + 'RoleAction/SearchActionsByCode',
  URL_RULES_BY_CODE_AND_PAYOR: environment.url_api + 'RoleAction/SearchActionsByCode',

  /**
   * Unprocessed Claims
   */
  URL_GET_INCOMPLETE_TRIPS: environment.url_api + 'Trip/TripsNotCompletedByProvider/',
  URL_GET_TRIPS_READY_TO_BILL: environment.url_api + 'Trip/TripsCompletedByProvider/',
  URL_GET_SUBMIT_TRIPS: environment.url_api + 'Trip/SubmitTripsByProvider',
  URL_GET_VALIDATE_SUBMIT_TRIPS: environment.url_api + 'Trip/ValidateSubmitTripsByProvider',
  URL_GET_CLAIM_BATCH_BY_PROVIDER: environment.url_api + 'Claim/ClaimsByCompany/',
  URL_GET_CLAIM_BATCH_DETAIL_BY_PROVIDER: environment.url_api + 'Claim/',
  URL_GET_PAID_BATCH: environment.url_api + 'PaymentBatch/SearchByProvider/',
  URL_GET_PAID_BATCH_DETAIL: environment.url_api + 'PaymentBatch/SearchByProvider/',
  URL_GET_CLAIM_BATCH_REPORT: environment.url_api + 'Report/ClaimByBatch/',
  URL_GET_EOP_BATCH_REPORT: environment.url_api + 'Report/CreateEopPdf/Company/',
  URL_CLAIMS_COUNT: environment.url_api + 'Claim/DeniedClaimsCount',

  /**
   * Payment Denied
   */
  URL_GET_PAYMENT_DENIED: environment.url_api + 'Trip/TripsPaymentDeniedByProvider/',

  URL_VERSION_APP: environment.url_api + 'Configuration',
  URL_VERSION_WEBAPP: environment.url_api + 'Configuration/SearchByDescription/VersionWebAppFront',

  /**
   * Dashboard Claims
   */
  URL_GET_SUMARY_CLAIMS: environment.url_api + 'Claim/SummaryClaim/',
  URL_GET_REPORT_CLAIM: environment.url_api + 'Report/ClaimTrips',
  URL_GET_REPORT_CLAIMS: environment.url_api + 'Claim/ProviderClaimTrip',
  URL_COUNTY: environment.url_api + 'County',
  URL_COUNTY_ZIP_CODE: environment.url_api + 'CountyZipCode/List',
  URL_COUNTY_COUNTY_UPDATE: environment.url_api + 'CountyZipCode',
  URL_PROVIDER_COUNTY_GET: environment.url_api + 'ProviderCountyZipCode/List/',
  URL_PROVIDER_COUNTY_PUT: environment.url_api + 'ProviderCountyZipCode',

  URL_REPORT: environment.url_api + 'Report',

  URL_PROVIDER_COUNTY_ZIP_CODE: environment.url_api + 'ProviderCountyZipCode',
  URL_GET_PROVIDER_COUNTY_Zip_CODE: environment.url_api + 'ProviderCountyZipCode',

  URL_MANAGER_REPORTS: environment.url_api + 'RoleAction/MenuReportsHtml',

  URL_CATEGORY_TYPE_LICENSE: environment.url_api + 'CategoryTypeLicense',
  URL_TYPE_LICENSE: environment.url_api + 'TypeLicense',

  URL_TYPE_LICENSE_PROVIDER: environment.url_api + 'TypeLicenseProvider',
  URL_PROVIDER_LICENSE: environment.url_api + 'ProviderLicense',
  URL_PROPIVER_LICENSE_STATUS: environment.url_api + 'ProviderLicenseStatus',

  // SKILLS
  URL_SKILL: environment.url_api + 'Skill',

  // AUTOROUTING_SETTING
  URL_AUTOROUTING_SETTING: environment.url_api + 'AutoroutingSetting',

  // AUTOROUTING
  URL_AUTOROUTING: environment.url_api + 'Autorouting',
  URL_AUTOROUTING_EXPORT: environment.url_api + 'Autorouting/Export',
  URL_DRIVER_ETA: environment.url_api + 'Autorouting/Eta',

  // DRIVER SCHEDULES
  URL_DRIVER_SCHEDULE: environment.url_api + 'Schedule',
  URL_DRIVER_SCHEDULE_LIST: environment.url_api + 'Schedule/List',
  URL_DRIVER_SCHEDULE_ADD: environment.url_api + 'Schedule/AddDriverSchedule',
  URL_DRIVER_SCHEDULE_PASTE: environment.url_api + 'Schedule/PasteDriverSchedule',
  URL_DRIVER_SCHEDULE_RESET: environment.url_api + 'Schedule/ResetDriverSchedule',
  URL_DRIVER_SCHEDULE_HISTORY: environment.url_api + 'Schedule/History',
  URL_CHANGE_COMPANY_SO: environment.url_api + 'StandingOrder/ChangeCompany',
  URL_SO_HISTORY: environment.url_api +  'StandingOrder/searchHistory/',
  URL_SO_HISTORY_ATTACH: environment.url_api +  'StandingOrder/AttachFileToSoHistory',
  URL_STANDING_NOTES: environment.url_api + 'StandingOrderNote',
  URL_AMBULATORY_AUTOROUTING: environment.url_api + 'Autorouting/Generate',

  // DEPOT
  URL_DEPOT: environment.url_api + 'Depot',
  URL_DEPOT_BY_PROVIDER: environment.url_api + 'Depot/ListByProvider/',

  // DUBDIVISIONS
  URL_SUBDIVISIONS: environment.url_api + 'CompanySubDivision',

  // AUTO ROUTING
  URL_AUTO_ROUTING_DRIVERS: environment.url_api + 'Autorouting/$jobId/drivers',
  URL_AUTO_ROUTING_UNASSIGNEDTRIPS: environment.url_api + 'Autorouting/$jobId/unassignedTrips',
  URL_AUTO_ROUTING_VEHICLES_TRIPS: environment.url_api + '/Autorouting/$jobId/Trips/$scheduleId',
  URL_AUTO_ROUTING_CAPACITY_TYPES: environment.url_api + 'AutoroutingSetting/CapacityType',
  URL_AUTO_ROUTING_CAPACITIES_BY_VEHICLE: environment.url_api + 'VehicleCapacity/ListByVehicle/',
  URL_AUTO_ROUTING_ERASE: environment.url_api + '/Autorouting?',
  URL_AUTO_ROUTING_RECALCULATE: environment.url_api + 'Autorouting/',

  URL_AUTO_ROUTING_ASSIGN: environment.url_api + '/Autorouting/assign',
  URL_AUTO_ROUTING_CHANGE_ORDER: environment.url_api + '/Autorouting/changeOrder',
  URL_FILTER: environment.url_api + 'Filter',
  statusList : [
    {value: 'Open', id: 1},
    {value: 'Active', id: 2},
    {value: 'Accepted', id: 3},
    {value: 'Pickup', id: 5},
    {value: 'NoShow', id: 6},
    {value: 'Cancelled', id: 7},
    {value: 'Completed', id: 10},
    {value: 'Hold', id: 14},
    {value: 'Arrived', id: 16},
  ],
  statusGroupList : [
    {value: 'Incomplete', id: 1},
    {value: 'NoShow', id: 2},
    {value: 'Cancelled', id: 3},
    {value: 'Completed', id: 4}
  ],

  /**
   * @description Approval - Appeal Claim Trip
   */
  URL_PAYMENT_DENIED_REASON: environment.url_api + 'PaymentDeniedReason',
  URL_TRIP_HISTORY_DETAIL: environment.url_api + 'Trip/TripHistoryDetail',
  URL_CLAIM_APPEAL: environment.url_api + 'Claim/Appeal',
  URL_POST_CONFORMATION: environment.url_api + '/Trip/PostConfirmation',

  /**
   * @description Services Import Settings
   */
  URL_IMPORT_TYPE: environment.url_api +  'ImportType',
  URL_IMPORT_TEMPLATE: environment.url_api + 'ImportTemplate',
  URL_MESSAGE: environment.url_api + 'Message',
  /**
   * @name Message trip submit
   */
  MESSAGE_TRIP_SUBMIT: ' I certify that the foregoing information is true, accurate, and complete. I understand that ' +
    'payment of this claim will be from Federal and State funds, and that any falsification, or concealment of a material fact, ' +
    'may be prosecuted under Federal and State laws.',

  MESSAGE_EOB_NOT_AVAILABLE: 'This claim has not been processed yet. The claim must either be Denied or have an ' +
    'associated Paid payment before the system can generate an EOB.',

  URL_PRIORITY: environment.url_api + 'Priority',
  URL_NATURE: environment.url_api + 'Nature',
  URL_CONFIGURATION: environment.url_api + 'Configuration',

  URL_LOCATION_TRACKER: environment.url_api + 'LocationTracker',
  URL_VEHICLE_UPDATE_UNIT: environment.url_api + 'Vehicle/UpdateUnit',

  CLAIM_STATUS: environment.url_api + 'Claim/ClaimStatus',
  COMPLAINT_HISTORY: environment.url_api + 'ComplaintHistory',
  COMPLAINT_DASHBOARD: environment.url_api + 'ComplaintDashboard',
  SEND_TRIP2_CLM_TO_ORIGIN: environment.url_api + 'Integration/SendTripsClmToOrigin ',
  URL_SERVICE_PROVIDER: environment.url_api + 'ServiceProvider',
  URL_SERVICE_PROVIDER_SEARCH: environment.url_api + 'ServiceProvider/Search',
  URL_REASONS_DELAY: environment.url_api + 'TripLateReason',
  URL_SERVICE_INVOICE_BATCH: environment.url_api + 'InvoiceBatch',
  URL_SERVICE_INVOICE_BATCH_SEND_EMAIL: environment.url_api + 'InvoiceBatch/InvoiceSendEmail',
  URL_SERVICE_GET_LIST_TRIPS: environment.url_api + 'InvoiceBatch/ListTrips',
  URL_GET_INVOICE_BATCH_BY_ID: environment.url_api + 'InvoiceBatch/InvoiceBatchById',
  URL_COMPLAINT_HISTORY_FILE: environment.url_api + 'ComplaintHistory/Documents/',
  URL_SERVICE_PROVIDER_MERGE: environment.url_api + 'ServiceProvider/MergeServiceProvider' ,

  TRIPS_MADE_BY_RIDER: `${environment.url_api}Confirmation/TripCreatedByRider`,

  ALERT_TYPES: `${environment.url_api}AlertType`,
  RIDER_ALERTS: `${environment.url_api}RiderAlert`,
  URL_RIDER_ALERTS_BY_TYPE: `${environment.url_api}RiderAlert/ByTypeAlert`,
  /**
   * PAYOR OVERRIDE
   */
  URL_COMPANY_PAYOR_OVERRIDE: environment.url_api + 'CompanyPayorOverride',
  URL_COMPANY_PAYOR_OVERRIDE_BY_COMPANY: environment.url_api + 'CompanyPayorOverride/ByCompany',

  /**
   * SCHEDULE TRIPS
   */
  URL_SCHEDULE_TRIPS_ROUTE_TO_PICK_UP: environment.url_api + 'ScheduleTrip/RouteToPickUp',
  URL_TRIP_ROUTE_DETAILS: environment.url_api + 'TripRoute/TripDetails',
  /**
   * INTEGRATION LYFT
   */
  URL_SEND_TO_LYFT: environment.url_api + 'Lyft/SendTrip',
  URL_CANCEL_SEND_TO_LYFT: environment.url_api + 'Lyft/Cancel',
  URL_VERIFY_TO_LYFT: environment.url_api + 'Lyft/IsSent',
    /**
   * INTEGRATION UBER
   */
     URL_SEND_TO_UBER: environment.url_api + 'Uber/SendTrip',
     URL_CANCEL_SEND_TO_UBER: environment.url_api + 'Uber/Cancel',
     URL_VERIFY_TO_UBER: environment.url_api + 'Uber/IsSent',

  /**
   * EXTERNAL INTEGRATION
  */
  URL_BASE_EXTERNAL_INTEGRATION: `${environment.url_api}External`,
  URL_EXTERNAL_INTEGRATION_SEND_TRIPS: `${environment.url_api}External/SendTrips`,
  URL_EXTERNAL_INTEGRATION_HAS_EXTERNAL_SETTING: `${environment.url_api}External/HasExternalSetting`,

  /**
   * PROVIDER HISTORY
   */
  URL_PROVIDER_HISTORY: environment.url_api + 'ProviderHistory',
  /**
   * LIVE MAP DISPATCH
   */
  URL_LOCATION_DRIVERS: environment.url_api + 'LiveMap/LocationDrivers',
  URL_DRIVER_SCHEDULE_TRIPS: environment.url_api + 'ScheduleTrip/List',
  URL_LIVE_MAP_DISPATCH_ACTIVE_TRIPS: environment.url_api + 'LiveMap/ActiveTrips',
  URL_OSRM_TRIP_DRIVING: environment.url_osrm + 'trip/v1/driving/',
  URL_OSRM_ROUTE_DRIVING: environment.url_osrm + 'route/v1/driving/',

  /*
  * POSTING
  */
  URL_POSTING: environment.url_api + 'Posting',
  URL_GET_POSTING_CREDIT_LIST: environment.url_api + 'Posting/batchInfoList',
  URL_POST_BATCH_CREDIT: environment.url_api + 'Posting/SaveBatchInfo',
  URL_UPDATE_BATCH_INFO: environment.url_api + 'Posting/UpdateBatchInfo',
  URL_GET_CREDIT_TYPE_LIST: environment.url_api + 'Credit/GetByType',
  URL_SEARCH_POSTING_RESERVATION: environment.url_api + 'Posting/searchTrip',
  URL_POST_POSTING_BATCH_CREDIT: environment.url_api + 'Posting/SaveBatchCredit',
  URL_GET_DELETE_BATCH_CREDIT: environment.url_api + 'Posting/deleteBatchCredit',
  URL_GET_BATCH_CREDIT: environment.url_api + 'Posting/GetBatchCreditByTrip',
  URL_PUT_BATCH_CREDIT: environment.url_api + 'Posting/UpdateBatchCredit',
  URL_POSTING_BATCH_CREDIT: environment.url_api + 'Posting/postingBatchCredit',
  URL_AUTO_FILL: environment.url_api + 'Posting/autoFill',
  URL_DELETE_ALL_BATCH: environment.url_api + 'Posting/deleteAllBatch',
  URL_ROLLBACK_BATCH: environment.url_api + 'Posting/rollBackBatch',

  /**
     * AUTHORIZATION ENDPOINT
  */
  URL_TRIP_AUTHORIZATION: environment.url_api + 'PayorAuthorization',
  URL_STATUS_LIST_TRIP_AUTHORIZATION: environment.url_api + 'PayorAuthorization/statusList',
  URL_LIST_TRIP_AUTHORIZATION: environment.url_api + 'PayorAuthorization/tripList',
  URL_TRIP_COUNT_BY_STATUS: environment.url_api + 'PayorAuthorization/TripCountByStatus',

  /*
  * BACKGROUND-CHECKS
  */

  URL_GET_BACKGROUND_CHECK: environment.url_api + 'BackgroundCheck/List',
  URL_GET_BACKGROUND_CHECK_APPROVE: environment.url_api + 'BackgroundCheck/ChangeApplicationStatus',
  URL_GET_BACKGROUND_CHECK_COUNTS: environment.url_api + 'BackgroundCheck/Counts',
  URL_GET_BACKGROUND_CHECK_RENEWALS: environment.url_api + 'BackgroundCheck/Renewals',
  URL_GET_BACKGROUND_CHECK_DRIVER_DETAIL: environment.url_api + 'BackgroundCheck/Detail',

    /*
   ZipCodeFlorida
   */
   URL_ZIPCODES_FLORIDA: environment.url_api + 'ZipCodesFlorida',
   URL_GET_ZIPCODES_FLORIDA_BY_ID: environment.url_api + 'ZipCodesFlorida/SearchByZipCode',
  /*
   Payor Default Ride2MD
   */
  PAYOR_DEFAULT_RIDE2MD: [6],

  UNVERIFIED_TRIPS: {
    NEXT_BILLING_STATUS_LIST: [
      {name: 'Verified', value: BillingStatusEnum.Verified, typeList: 1},
      {name: 'Unverified', value: BillingStatusEnum.Unverified, typeList: 2},
      {name: 'Rejected', value: BillingStatusEnum.Rejected, typeList: 2},
      {name: 'Closed', value: BillingStatusEnum.Closed, typeList: 2},
      {name: 'Billed', value: BillingStatusEnum.Billed, typeList: 2},
      {name: 'Pending', value: BillingStatusEnum.Pending, typeList: 2}
    ],
    TABS_UNVERIFIED_TRIPS: {
      UnverifiedTrips: TabsUnverifiedTripsEnum.UnverifiedTrips,
      ExportZoll: TabsUnverifiedTripsEnum.ExportZoll,
      ElectronicSubmissions: TabsUnverifiedTripsEnum.ElectronicSubmissions,
      ECM: TabsUnverifiedTripsEnum.ECM,
      Forms: TabsUnverifiedTripsEnum.Forms,
      SummaryTrips: TabsUnverifiedTripsEnum.SummaryTrips,
      Rejections: TabsUnverifiedTripsEnum.Rejections
    }
  },

  DEPOSITS_POSTING: {
    TABS_DEPOSITS: {
      Deposits: TabsDepositsEnum.Deposits,
      Detail: TabsDepositsEnum.Detail,
      LockBox: TabsDepositsEnum.LockBox,
      Posted: TabsDepositsEnum.Posted,
      Conciliation: TabsDepositsEnum.Conciliation,
      OfficeDeposit: TabsDepositsEnum.OfficeDeposit,
      Electronic: TabsDepositsEnum.Electronic,
      WriteOff: TabsDepositsEnum.WriteOff,
    },
    TABS_ELECTRONIC: {
      Claim: TabsElectronicEnum.Claims,
      ClaimDetail: TabsElectronicEnum.ClaimsDetail,
      RemitSummary: TabsElectronicEnum.RemitSummary
    }
  },

  SERVICE_PROVIDER: {
    TABS_SERVICE_PROVIDER: {
      Forms: TabsServiceProviderEnum.Form,
      History: TabsServiceProviderEnum.History,
    }
  },

   DENIALS: {
    TABS_DENIALS: {
      Details: TabsDenialsEnum.Details,
      Eligibility: TabsDenialsEnum.Eligibility,
    }
  },

  FAX_REQUESTED_ENUM: {
    Received : FaxRequestedEnum.Received,
    OnReview : FaxRequestedEnum.OnReview,
    Invalid : FaxRequestedEnum.Invalid,
    Worked : FaxRequestedEnum.Worked,
    Blank : FaxRequestedEnum.Blank,
    Repeated : FaxRequestedEnum.Repeated,
    Error : FaxRequestedEnum.Error,
  },

  TOTAL_MILES_ALERT_LYFT: 50,

  BILLING_STATUS_LIST: {
    Unverified: 1,
    Verified: 2,
    Billed: 3,
    Rejected: 4,
    Denied: 5,
    Closed: 6,
    Processing: 7,
    Pending: 8,
    Refund: 9
  },

  /**
  * QUIZ ENDPOINT
  * */

  URL_BASE_QUIZ: environment.url_api + 'Quiz',
  URL_BASE_QUIZ_QUESTION: environment.url_api + 'Quiz/Question',
  URL_BASE_QUIZ_ANSWER: environment.url_api + 'Quiz/Answer',

  /*
  * LANGUAGE
  */

  URL_GET_LANGUAGE: environment.url_api + 'Language',

  /*
  * Edi Files
  */

  URL_GET_EDI_FILES: environment.url_api + 'EdiFile/SearchEdiFile',
  URL_IMPORT_EDI_FILE: environment.url_api + 'FormExport/DownloadFile',

/**
    LINKED PROVIDER
 * ** */

  URL_LINKEDPROVIDER: environment.url_api + 'LinkedProvider',

   /*
  * Note Category Value
  */

   URL_GET_NOTECATEGORY: environment.url_api + 'TripNote/NoteCategoryValues',

  /** IMPORT INVOICES  */
  URL_POST_IMPORT_INVOICES: environment.url_api + 'PayorInvoice/importFile',
  URL_GET_IMPORT_COMPANIES_INVOICES: environment.url_api + 'PayorInvoice/GetCompanies',
  URL_GET_IMPORT_COMPANY_BY_ID: environment.url_api + 'PayorInvoice/GetCompany',
  URL_POST_PAYOR_INVOICES: environment.url_api + 'PayorInvoice/GetPayorInvoice',
  URL_GET_STATUS_INVOICES: environment.url_api + 'PayorInvoice/GetStatus',
  URL_GET_HISTORY_INVOICES: environment.url_api + 'PayorInvoice/GetHistoryByPayorInvoice',
  URL_GET_SEARCH_BY__PAYOR_INVOICE_ID: environment.url_api + 'PayorInvoice/SearchPayorInvoiceById',
  URL_POST_UPLOADDOCUMENT: environment.url_api + 'PayorInvoice/UploadDocument',
  URL_GET_DOCUMENTSBYPAYORINVOICE: environment.url_api + 'PayorInvoice/GetDocumentsByPayorInvoice',
  URL_PAYORINVOICES: environment.url_api + 'PayorInvoice',
  URL_DELETE_DOCUMENT: environment.url_api + 'PayorInvoice/DeleteDocument',
  URL_GET_PAYMENT: environment.url_api + 'PayorInvoice/GetPaymentsByPayorInvoice',
  URL_POST_INVOICE_CHANGE_STATUS: environment.url_api + 'PayorInvoice/ChangeStatusMassive',
  URL_POST_INVOICE_SENT_EMAIL: environment.url_api + 'PayorInvoice/SendEmailInvoices',
  URL_POST_INVOICE_PREVIEW_BODY_MESSAGE: environment.url_api + 'PayorInvoice/GetEmailBodyPreview',
  URL_GET_PAYOR_INVOICE_SETTING: environment.url_api + 'PayorInvoice/GetPayorInvoiceSetting',
  URL_POST_UPDATE_PAYORINVOICE_STATUS: environment.url_api + 'PayorInvoice/UpdatePayorInvoiceStatus',
  URL_GET_PAYOR_PROFIT_CENTER: environment.url_api + 'PayorInvoice/GetProfitCenterByPayorId',
  URL_POST_PAYOR_PROFIT_CENTER: environment.url_api + 'PayorInvoice/PostProfitCenter',
  URL_PUT_PAYOR_PROFIT_CENTER: environment.url_api + 'PayorInvoice/PutProfitCenter',
  URL_POST_EXTERNAL_COMPANY: environment.url_api + 'PayorInvoice/PostExternalCompany',
  URL_PUT_EXTERNAL_COMPANY: environment.url_api + 'PayorInvoice/PutExternalCompany',
  URL_GET_SMTP_SETTING: environment.url_api + 'PayorInvoice/GetSmtpSetting',
  URL_POST_UPLOADDOCUMENT_MASSIVE: environment.url_api + 'PayorInvoice/UploadDocumentMassive',
  URL_POST_CHANGE_STATUS_CENTER: environment.url_api + 'PayorInvoice/ChangeStatusPayorProfitCenter',
  URL_GET_CONFIGURATION: environment.url_api + 'PayorInvoice/GetConfiguration',
  URL_GET_PROFITS_AND_PAYOR: environment.url_api + 'PayorInvoice/GetProfitsAndPayors',
  URL_PUT_PROFITS_AND_PAYOR: environment.url_api + 'PayorInvoice/PutProfitCenterOrPayor',
  URL_GET_COMPARER: environment.url_api + 'PayorInvoice/SearchPayorInvoiceComparer',
  URL_GET_SIGNATURE: environment.url_api + 'PayorInvoice/GetSignatureByUser',
  URL_POST_SIGNATURE: environment.url_api + 'PayorInvoice/PostSignatureByUser',
  URL_GET_BILLING_EMAILS: environment.url_api + 'PayorInvoice/GetBillingEmails',
  URL_GET_PAYOR_INVOICE_DEMAND_LETTER: environment.url_api + 'PayorInvoice',

  URL_MOBILE_APP: environment.url_api + 'MobileApp',
  URL_MOBILE_APP_DELETE: environment.url_api + 'MobileApp/DeleteMobileApp',
  URL_MOBILE_APP_VERSIONS: environment.url_api + 'MobileApp/Versions',
  URL_MOBILE_APP_HISTORY: environment.url_api + 'MobileApp/History',

   /** Drivers License  */

  URL_GET_DRIVER_VERIFIED: environment.url_api + 'DriverLicense/GetDriversVerified',
  URL_GET_DRIVER_INFO: environment.url_api + 'DriverLicense/GetDriverInfo',
  URL_UPDATE_DRIVER_LICENSE: environment.url_api + 'DriverLicense/UpdateDriverLicense',
  URL_EXTRACT_LICENSE_DOCUMENT: environment.url_api + 'DriverLicense/ExtractDocument',
  URL_POST_VERIFICATION_MASSIVE: environment.url_api + 'DriverLicense/GenerateMvrVerification',
  URL_POST_VERIFICATION: environment.url_api + 'DriverLicense/GenerateMvrVerification',
  URL_GET_ATTACHMENT_BYID: environment.url_api + 'DriverLicense/GetMvrAttachmentById',
  URL_POST_ATTACHMENT_BYLIST: environment.url_api + 'DriverLicense/GetMvrAttachmentByList',
  URL_POST_VERIFYLICENSE_MASSIVE: environment.url_api + 'DriverLicense/VerifyLicenseMassive',

  /** Live Trip **/
  URL_LIVE_TRIP: environment.url_api + 'LiveTrip',
  URL_LIVE_TRIP_SEND_TRACKING: environment.url_api + 'LiveTrip/SendTripTrackingToTheRider',

  /** Vehicle Inspection **/
  URL_GET_VEHICLE_INSPECTION_QUESTIONS: environment.url_api + 'VehicleInspection/GetAllVehicleInspectionQuestions',
  URL_GET_VEHICLE_INSPECTION_QUESTION_TYPES: environment.url_api + 'VehicleInspection/GetAllTypes',
  URL_ADD_VEHICLE_INSPECTION_QUESTION: environment.url_api + 'VehicleInspection/AddVehicleInspectionQuestion',
  URL_GET_VEHICLE_INSPECTION_QUESTIONS_PROVIDER: environment.url_api + 'VehicleInspection/ProviderVehicleInspectionQuestions',
  URL_UPDATE_VEHICLE_INSPECTION_QUESTION: environment.url_api + 'VehicleInspection/UpdateVehicleInspectionQuestion',

  /** Regions **/
  URL_REGION: environment.url_api + 'Region',

  /** Provider TA Portal Cost Centers **/
  URL_PROVIDER_TA_PORTAL_COST_CENTER: environment.url_api + 'ProviderTaPortalCostCenter',
  URL_PROVIDER_TA_PORTAL_COST_CENTER_CATALOG: environment.url_api + 'ProviderTaPortalCostCenter/Catalog',
  URL_PROVIDER_TA_PORTAL_COST_CENTER_BY_PROVIDER: environment.url_api + 'ProviderTaPortalCostCenter/ListByProvider',
  URL_PROVIDER_TA_PORTAL_COST_CENTER_BY_DRIVER: environment.url_api + 'ProviderTaPortalCostCenter/ByDriver',
  LIST_URL_DRIVERS_BY_TA_PORTAL_COST_CENTER: environment.url_api + 'MCTDriver/ListByTaPortalCostCenter',

  /** Posts **/
  URL_POSTS: environment.url_api + 'Post',
  URL_POST_ATTACHMENT: environment.url_api + 'PostAttachment',

  /* Qualification */
  URL_QUALIFICATION: environment.url_api + 'Qualification',
  URL_QUALIFICATION_DISABLE: environment.url_api + 'Qualification/Disable',
  URL_QUALIFICATION_ASSIGN_TO_DRIVER: environment.url_api + 'Qualification/AssignQualificationsToDriver',
  URL_QUALIFICATION_DRIVER_PAY: environment.url_api + 'Qualification/DriverPay',
  URL_QUALIFICATION_BY_PROVIDER: environment.url_api + 'Qualification/ByProvider',

  /*
  * External Authentication
  */

  URL_MICROSOFT_LOGIN_URL: environment.url_api + 'Microsoft/LoginUrl',
  URL_MICROSOFT_HAS_INTEGRATION: environment.url_api + 'Microsoft/HasIntegration',
  URL_GET_URL_VALIDATE_TOKEN: environment.url_api + 'Session/ValidateTokenJwt',

  /*
  * Value Mapping
  */
  URL_VALUE_MAPPING: environment.url_api + 'ValueMapping',
};



// WEBPACK FOOTER //
// ./src/app/app.constants.ts